import firebase from "firebase/app";
import "firebase/firestore";
import {
  useDocumentData,
  useCollectionDataOnce,
} from "react-firebase-hooks/firestore";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { Conference, ConferenceGroup, WithId } from "@kaigi100-next/typing";
import { useEffect } from "react";
import { conferenceConverter } from "lib/firebase/converters/conference";

export const currentConferenceState = atom<WithId<Conference>>({
  key: "currentConference",
  default: undefined,
});

export const conferenceGroupState = atom<ConferenceGroup>({
  key: "conferenceGroupState",
  default: undefined,
});

export function setCurrentConference(conferenceId: string) {
  const [conferenceDocumentData, loading, error] = useDocumentData<
    WithId<Conference>
  >(
    conferenceId &&
      firebase
        .firestore()
        .doc(`live/v1/conferences/${conferenceId}`)
        .withConverter(conferenceConverter),
    {
      idField: "id",
    }
  );
  const [conferenceGroupCollection] = useCollectionDataOnce<ConferenceGroup>(
    conferenceId &&
      firebase
        .firestore()
        .collection("conferenceGroups")
        .where("conferenceIds", "array-contains", conferenceId)
        .limit(1)
  );
  const [currentConference, setConference] = useRecoilState<WithId<Conference>>(
    currentConferenceState
  );
  const setConferenceGroup = useSetRecoilState(conferenceGroupState);
  useEffect(() => {
    setConference(conferenceDocumentData);
  }, [conferenceDocumentData]);
  useEffect(() => {
    console.log(conferenceGroupCollection);
    if (!conferenceGroupCollection || conferenceGroupCollection.length < 1) {
      return;
    }
    console.log(conferenceGroupCollection);
    setConferenceGroup(conferenceGroupCollection[0]);
  }, [conferenceGroupCollection]);

  return {
    currentConference,
    loading: loading || !currentConference,
  };
}

export function useCurrentConference() {
  const currentConference = useRecoilValue(currentConferenceState);
  return currentConference;
}

export function useConferenceGroup() {
  return useRecoilValue(conferenceGroupState);
}
